import { syncService } from './syncService';
import { Form, useNavigate, useOutletContext } from "react-router";
import React, { useState } from 'react'
import { Button, Field, Fieldset, Input, Label } from '@headlessui/react';
import { Bars3Icon, BellIcon, XMarkIcon, ArrowRightIcon } from '@heroicons/react/24/outline'

export async function welcomeLoader({ }) {
  return { };
}

let navigate = {};
export function Welcome({ }) {
  navigate = useNavigate();
  const { activeAccount } = useOutletContext();

  return (
    <>
      <div className="h-screen min-w-full overflow-hidden bg-black font-pin relative">
        <div className="absolute top-0 right-0 p-6">
          <img
            alt="Yellow"
            src="/yellow.svg"
            className=""
          />
        </div>

        <div className="absolute -right-16 w-32 h-32 bg-pvs-gray rotate-45 rounded-lg top-1/2 ">

        </div>

        <div className="absolute -right-16 w-32 h-32 top-1/2 flex items-center justify-center ">
        <Form action="/welcome" method="post" >
          <Button type="submit"><ArrowRightIcon className="h-8 pr-12 bold" ></ArrowRightIcon></Button>
          
        </Form>
        </div>

        <div className="flex items-center h-full">
          <div className="grid grid-cols-6 gap-4 pl-4">
            <div className="col-span-5 bg-white col-start-2">
              <img
                alt="PVS"
                src="/truck.svg"
                className="min-w-full bg-black"
              />
            </div>
            <div className="col-span-2">
              <img
                alt="PVS"
                src="/logo.svg"
                className="min-w-5/6  p-5 bg-black"
              />
            </div>
            <div className="col-span-5 pl-4">
              <span className="text-5xl font-inter">
                Welcome
              </span>
            </div>
            <div className="col-span-5 col-start-1 bg-black">
              <Form action="/welcome" method="post" >
                <input type="hidden" id="token" name="token" value={activeAccount.idToken}></input>
                <Button type="submit" className="w-full bg-pvs-gray block rounded p-3.5 items-center justify-center text-white mt-2 mb-16">Sync today's orders</Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export async function callWelcomeSync(request) {
  let formData = await request.formData();
  console.log("syncing");
  await syncService.syncShipments(formData.get("token"))
  navigate("/shipments")
}

